export const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export const FALLBACK_ADMIN_EMAILS = ['janapro@gmx.de'];

export const isAllowedAdminEmail = (allowedEmails, email) => {
  const want = normalizeEmail(email);
  if (!want) return false;
  const list = [...(allowedEmails || []), ...FALLBACK_ADMIN_EMAILS];
  return list.some((entry) => normalizeEmail(entry) === want);
};
